export default __webpack_public_path__ + "static/media/RS_color.bec0d92a.png";